import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import { Fade } from 'react-awesome-reveal'
import { StaticImage } from 'gatsby-plugin-image'
import Divider from '../../../components/Divider'

import FinServicesIcon from '../../../assets/Home/Icons/financial_services.svg'
import KYCIcon from '../../../assets/Home/Icons/kyc_aml.svg'
import TeleCommIcon from '../../../assets/Home/Icons/telecommunication.svg'
import HealthcareIcon from '../../../assets/Home/Icons/healthcare.svg'
import SharedEconIcon from '../../../assets/Home/Icons/economy.svg'
import GovernmentsIcon from '../../../assets/Home/Icons/governments.svg'
import RetailIcon from '../../../assets/Home/Icons/retail.svg'
import TourismIcon from '../../../assets/Home/Icons/tourism.svg'
import GamingIcon from '../../../assets/Home/Icons/gaming.svg'

import LimitLiabilityIcon from '../../../assets/Home/Icons/limit_data.svg'
import ImproveUXIcon from '../../../assets/Home/Icons/improve_ux.svg'
import ComplianceIcon from '../../../assets/Home/Icons/compliance.svg'

import VerificationIcon from '../../../assets/Home/Icons/verification.svg'
import OnboardingIcon from '../../../assets/Home/Icons/onboarding.svg'
import AuditIcon from '../../../assets/Home/Icons/audit.svg'
import LinkButton from '../../../components/LinkButton'
import routes from '../../../routes'
import CustomFadeSlide from '../../../components/RevealAnim/CustomFadeSlide'

const DashboardScreen = '../../../assets/Home/Images/onboarding4.png'
const useStyles = makeStyles((theme) => ({
  /**
   * || Reusable Componenets
   * ======================================= */
  sectionTitle: {
    marginBottom: 15,

    maxWidth: 280,

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 320,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 550,
    },
  },
  sectionDescription: {
    maxWidth: 350,

    color: 'rgba(115, 115, 115, 1)',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 500,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 600,
      fontSize: 16,
    },
  },
  sectionTitleInvest: {
    marginBottom: 15,

    maxWidth: 280,

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      display: 'none',
    },
  },
  sectionDescriptionInvest: {
    maxWidth: 350,

    color: 'rgba(115, 115, 115, 1)',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      display: 'none',
    },
  },

  /**
   * || Applicable Industries Section
   * ======================================= */
  industrySection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    margin: '130px auto',

    [theme.breakpoints.up('desktop')]: {
      margin: '150px auto',
    },
  },
  industryCardContainer: {
    display: 'grid',
    gridTemplate: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr / 1fr',
    placeItems: 'center',

    marginTop: 50,
    rowGap: 20,
    width: '100%',
    maxWidth: 1050,

    [theme.breakpoints.up('desktop')]: {
      gridTemplate: '1fr 1fr 1fr / 1fr 1fr 1fr',

      rowGap: 40,
    },
  },
  industryCard: {
    display: 'flex',
    alignItems: 'center',

    padding: '20px 30px',
    width: 300,

    border: '1px solid #E1E1E1',
    borderRadius: 5,
  },
  industryCardIcon: {
    width: 25,
    height: 25,
    marginRight: 20,

    color: '#2FA43B',
  },
  industryCardLabel: {
    color: 'black',
  },

  /**
   * || Data and Identity Management Section
   * ======================================= */
  dataManagementSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 40,

    [theme.breakpoints.up('tablet')]: {
      marginTop: 100,
    },
  },
  dataManagementFeatureContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 50,
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  dataManagementFeature: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    maxWidth: 360,
    margin: '50px auto 40px auto',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      margin: '50px 50px 40px 50px',
    },

    [theme.breakpoints.up('desktop')]: {
      margin: '50px 60px 40px 60px',
      maxWidth: 290,
    },
  },

  /**
   * || CycurID Dashboard Section
   * ======================================= */
  dashboardSectionWrapper: {
    margin: 'auto',
    width: '100%',
    // overflow: 'hidden',

    [theme.breakpoints.up('desktop')]: {
      marginTop: 100,
      marginBottom: 50,
    },
  },

  dashboardSection: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',

    maxWidth: theme.custom.maxWidth,
    padding: '80px 0px 40px 0px',
    width: '100%',

    background:
      'linear-gradient(179.63deg, #192B3E 61.31%, rgba(0, 0, 0, 0.28) 206.5%)',

    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      alignItems: 'center',
      background: 'transparent',

      zIndex: 1,
    },

    [theme.breakpoints.up('desktopXL')]: {
      margin: 'auto',
    },
  },
  dashboardBackground: {
    display: 'none',

    [theme.breakpoints.up('tablet')]: {
      display: 'block',
      position: 'absolute',

      width: '100%',
      height: '25%',
      top: '40%',

      background:
        'linear-gradient(179.63deg, #192B3E 61.31%, rgba(0, 0, 0, 0.28) 206.5%)',

      zIndex: -1,
    },
  },
  dashboardDescription: {
    marginTop: 15,
    maxWidth: 500,
    color: '#737373',
  },
  dashboardColumnLeft: {
    margin: '0px auto',
    padding: '30px 30px',
    maxWidth: '80%',

    background: '#FFFFFF',

    boxShadow: '0px 10px 50px rgba(0, 0, 0, 0.14)',
    borderRadius: 10,

    [theme.breakpoints.up('tablet')]: {
      margin: '0px 10px',
      maxWidth: 'unset',
      // minWidth: 425,
    },

    [theme.breakpoints.up('desktop')]: {
      minWidth: 425,

      position: 'relative',

      maxWidth: 470,
      margin: '0px 45px',
      left: '5%',
      padding: '45px',
    },

    [theme.breakpoints.up('desktopXL')]: {
      padding: '45px 60px',
    },
  },
  dashboardImg: {
    position: 'relative',
    overflow: 'hidden',
    height: 'auto',
    width: '100%',
    marginTop: 35,
    // background: '#F4F4F4',
    // boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.25)',
    // borderRadius: 20,
    '& img': {
      position: 'absolute',
      width: 'calc(600px + 3vw)',
      height: 'calc(345px + 3vw)',
    },

    [theme.breakpoints.up('tablet')]: {
      position: 'relative',
      // left: '7%',
      width: 'auto',
      height: 'auto',
      margin: 'auto 0px',

      '& img': {
        width: 'calc(600px + 12vw)',
        height: 'calc(545px + 12vw)',
      },
    },

    [theme.breakpoints.up('desktop')]: {
      width: '100%',
      height: 'auto',
      margin: 'auto 0px',

      '& img': {
        left: 'calc(10px + 2vw)',
        width: 'calc(560px + 22vw)',
        maxWidth: '960px',
      },
    },

    [theme.breakpoints.up('1180')]: {
      position: 'relative',
      // left: '7%',
      width: '100%',
      height: 'auto',
      margin: 'auto 0px',

      '& img': {
        width: 'calc(670px + 22vw)',
        maxWidth: '960px',
      },
    },

    [theme.breakpoints.up('1280')]: {
      position: 'relative',
      // left: '7%',
      width: '100%',
      height: 'auto',
      margin: 'auto 0px',

      '& img': {
        left: 'calc(60px + 2vw)',
        width: 'calc(780px + 22vw)',
        maxWidth: '1000px',
      },
    },

    [theme.breakpoints.up('1380')]: {
      '& img': {
        left: 'calc(115px + 2vw)',
      },
    },

    [theme.breakpoints.up('1430')]: {
      '& img': {
        left: 'calc(115px + 2vw)',
        maxWidth: '1050px',
      },
    },

    [theme.breakpoints.up('1480')]: {
      '& img': {
        left: 257,
        maxWidth: '1065px',
      },
    },
  },
  dashboardFeature: {
    marginTop: '30px',
    maxWidth: 500,
  },
  dashboardFeatureTitleRow: {
    display: 'flex',
    alignItems: 'center',

    marginBottom: 10,
  },
  dashboardFeatureIcon: {
    width: 25,
    height: 'auto',
    marginRight: 10,

    [theme.breakpoints.up('desktop')]: {
      width: 35,
    },
  },
  bar: {
    marginBottom: 15,

    [theme.breakpoints.up('tablet')]: {
      display: 'none',
    },
  },
  bigTasksDescription: {
    color: '#737373',
    textAlign: 'left',
    fontSize: 12,

    [theme.breakpoints.up('desktop')]: {
      fontSize: 16,
    },
  },
  bigTasksTitleDescription: {
    color: '#737373',
    textAlign: 'left',
    fontSize: 12,
    marginTop: 5,

    [theme.breakpoints.up('tablet')]: {
      marginTop: 20,
    },
    [theme.breakpoints.up('desktop')]: {
      fontSize: 16,
    },
  },
}))
export default function BusinessSection() {
  const classes = useStyles()
  const businessIndustries = [
    {
      title: 'Financial Services',
      icon: <FinServicesIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Healthcare',
      icon: <HealthcareIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Retail & Ecommerce',
      icon: <RetailIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'KYC/AML',
      icon: <KYCIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Shared Economy',
      icon: <SharedEconIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Tourism',
      icon: <TourismIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Telecommunication',
      icon: <TeleCommIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Governments',
      icon: <GovernmentsIcon className={classes.industryCardIcon} />,
    },
    {
      title: 'Gaming',
      icon: <GamingIcon className={classes.industryCardIcon} />,
    },
  ]

  return (
    <>
      <section className={classes.industrySection}>
        <Fade triggerOnce fraction={0.3}>
          <Divider style={{ marginBottom: 15 }} />
          <Typography variant='h2' className={`${classes.sectionTitle}`}>
            Whatever Your Business, <br />
            CycurID Makes You Better
          </Typography>
          <Typography
            variant='body1'
            className={`${classes.sectionDescription}`}
            style={{ marginBottom: 15 }}
          >
            If you do business online, you need to verify and authenticate
            customers while staying compliant with a host of legal regulations.
            This costs money and causes headaches for any organization.
            <br />
            <br />
            CycurID does not take half-measures by just alleviating symptoms of
            the bigger problem. We are fundamentally changing the way digital
            trust is built, revolutionizing everything from verification and
            authentication, to digital privacy and security.
          </Typography>
        </Fade>
        <div className={classes.industryCardContainer}>
          <Fade triggerOnce cascade duration={500} damping={0.3}>
            {businessIndustries.map((industry) => {
              return (
                <div className={classes.industryCard} key={industry.title}>
                  {industry.icon}
                  <Typography
                    variant='h3'
                    className={`${classes.industryCardLabel}`}
                  >
                    {industry.title}
                  </Typography>
                </div>
              )
            })}
          </Fade>
        </div>
        <div style={{ marginTop: 40 }}>
          <LinkButton href={routes.INDUSTRIES}>Learn More</LinkButton>
        </div>
      </section>
      <section className={classes.dashboardSectionWrapper}>
        <div className={classes.dashboardSection}>
          <div className={classes.dashboardBackground} />
          <Fade triggerOnce fraction={0.3}>
            <div className={classes.dashboardColumnLeft}>
              <Typography variant='h2' className={classes.dashboardTitle}>
                Big Tasks Made Easy
              </Typography>
              <Typography className={classes.bigTasksTitleDescription}>
                CycurID&apos;s solution is flexible, customizable, and simple to
                use, making it easy to integrate into your digital platforms.
              </Typography>

              <div className={classes.dashboardFeature}>
                <div className={classes.dashboardFeatureTitleRow}>
                  <VerificationIcon
                    color='#2fa43b'
                    className={classes.dashboardFeatureIcon}
                  />
                  <Typography variant='h3'>Verification Rules</Typography>
                </div>
                <Typography className={classes.bigTasksDescription}>
                  Choose what level of verification you require for customers to
                  access your services. Do they just need a verified email? Or
                  does your business require a verified address or
                  government-issued ID?
                </Typography>
              </div>

              <div className={classes.dashboardFeature}>
                <div className={classes.dashboardFeatureTitleRow}>
                  <OnboardingIcon
                    color='#2fa43b'
                    className={classes.dashboardFeatureIcon}
                  />
                  <Typography variant='h3'>Flexible Onboarding</Typography>
                </div>
                <Typography className={classes.bigTasksDescription}>
                  Set custom requirements for users accessing your services.
                  Automatically prevent users that don&apos;t meet age
                  requirements or aren&apos;t adequately verified from getting
                  in the door.
                </Typography>
              </div>
              <div className={classes.dashboardFeature}>
                <div className={classes.dashboardFeatureTitleRow}>
                  <AuditIcon
                    color='#2fa43b'
                    className={classes.dashboardFeatureIcon}
                  />
                  <Typography variant='h3'>Audited Information</Typography>
                </div>
                <Typography className={classes.bigTasksDescription}>
                  Confirm the verification checks CycurID has done for you by
                  viewing the verification history of specific users.
                </Typography>
              </div>
            </div>
          </Fade>
          <CustomFadeSlide delay={400} direction='right'>
            <StaticImage
              src={DashboardScreen}
              alt='CycurID Dashboard Signup Form'
              className={classes.dashboardImg}
              placeholder='blurred'
              objectFit='contain'
              quality={100}
            />
          </CustomFadeSlide>
        </div>

        <section className={classes.dataManagementSection}>
          <Fade triggerOnce fraction={0.3} delay={200}>
            <Divider className={classes.bar} />
            <Typography
              variant='h2'
              className={`${classes.sectionTitleInvest}`}
            >
              Invest in Your Business, Not in Redundancy
            </Typography>
            <Typography
              variant='body1'
              className={`${classes.sectionDescriptionInvest}`}
            >
              Digital Identity Management means more than managing data. Our
              technology can unlock benefits across many aspects of your
              business.
            </Typography>
          </Fade>
          <div className={classes.dataManagementFeatureContainer}>
            <Fade triggerOnce delay={200} cascade duration={600}>
              <div className={classes.dataManagementFeature}>
                <LimitLiabilityIcon color='#2FA43B' style={{ height: 35 }} />
                <Typography
                  variant='h3'
                  style={{ marginTop: 10, marginBottom: 8 }}
                >
                  Limit Data Liability
                </Typography>
                <Typography variant='body2' style={{ color: '#737373' }}>
                  Storing data to perform in-house KYC or authentication checks
                  makes your business a target for cybercrime. CycurID's
                  client-side Digital ID managing tools eliminate the need for
                  you to keep sensitive user data on-site.
                </Typography>
                {/* <LinkButton>Learn More</LinkButton> */}
              </div>
              <div className={classes.dataManagementFeature}>
                <ImproveUXIcon color='#2FA43B' style={{ height: 35 }} />
                <Typography
                  variant='h3'
                  style={{ marginTop: 10, marginBottom: 8 }}
                >
                  Improve User Experience
                </Typography>
                <Typography variant='body2' style={{ color: '#737373' }}>
                  Streamline your Onboarding and Authentication platforms by
                  going passwordless. CycurID helps you expedite your user
                  sign-up processes to get customers in the door and doing
                  business with you faster and easier.
                </Typography>
                {/* <LinkButton>Learn More</LinkButton> */}
              </div>
              <div className={classes.dataManagementFeature}>
                <ComplianceIcon color='#2FA43B' style={{ height: 35 }} />
                <Typography
                  variant='h3'
                  style={{ marginTop: 10, marginBottom: 8 }}
                >
                  Proactive Compliance
                </Typography>
                <Typography variant='body2' style={{ color: '#737373' }}>
                  Your KYC/AML procedures are only valid as long as your
                  customers&apos; data is up-to-date. CycurID’s continuous KYC
                  ensures that expired customer data never becomes an issue.
                </Typography>
                {/* <LinkButton>Learn More</LinkButton> */}
              </div>
            </Fade>
          </div>
        </section>
      </section>
    </>
  )
}
